import type { PowerId } from "./types";

export interface Swatch {
  light: string;
  base: string;
  dark: string;
  glow: string;
}

/** Cam tuğla renkleri. Amber altın, slate zırhlı tuğla için ayrıldı. */
export const BRICK_SWATCHES: Swatch[] = [
  { light: "#f5d0fe", base: "#d946ef", dark: "#86198f", glow: "#f0abfc" },
  { light: "#ddd6fe", base: "#7c3aed", dark: "#5b21b6", glow: "#c4b5fd" },
  { light: "#c7d2fe", base: "#4f46e5", dark: "#312e81", glow: "#a5b4fc" },
  { light: "#bae6fd", base: "#0284c7", dark: "#075985", glow: "#7dd3fc" },
  { light: "#99f6e4", base: "#0d9488", dark: "#115e59", glow: "#5eead4" },
  { light: "#a7f3d0", base: "#059669", dark: "#065f46", glow: "#6ee7b7" },
  { light: "#fde68a", base: "#d97706", dark: "#92400e", glow: "#fbbf24" },
  { light: "#fecdd3", base: "#e11d48", dark: "#9f1239", glow: "#fb7185" },
  { light: "#e2e8f0", base: "#64748b", dark: "#334155", glow: "#cbd5e1" },
];

export const RAINBOW = [0, 1, 2, 3, 4, 5, 7];
export const GOLD_SWATCH = 6;
export const ARMOR_SWATCH = 8;

export const swatchAt = (index: number): Swatch =>
  BRICK_SWATCHES[index % BRICK_SWATCHES.length] ?? BRICK_SWATCHES[0];

export interface PowerStyle {
  glow: string;
  core: string;
  ink: string;
}

export const POWER_STYLE: Record<PowerId, PowerStyle> = {
  expand: { glow: "#67e8f9", core: "#06b6d4", ink: "#083344" },
  shrink: { glow: "#fda4af", core: "#e11d48", ink: "#4c0519" },
  multi: { glow: "#fcd34d", core: "#d97706", ink: "#451a03" },
  slow: { glow: "#7dd3fc", core: "#0284c7", ink: "#082f49" },
  haste: { glow: "#fdba74", core: "#ea580c", ink: "#431407" },
  laser: { glow: "#f0abfc", core: "#c026d3", ink: "#4a044e" },
  pierce: { glow: "#fb923c", core: "#c2410c", ink: "#431407" },
  life: { glow: "#6ee7b7", core: "#059669", ink: "#022c22" },
  sticky: { glow: "#c4b5fd", core: "#7c3aed", ink: "#2e1065" },
  shield: { glow: "#5eead4", core: "#0f766e", ink: "#042f2e" },
  bomb: { glow: "#fb7185", core: "#be123c", ink: "#4c0519" },
};
